<template>
  <div class="color-container">
    <div class="hexagon" :style="`color: ${color};`" />

    <div class="color-label">{{ answer }}</div>
  </div>
</template>

<script>
export default {
  name: 'Color',
  props: {
    choices: {
      type: Array,
      required: true
    },
    expectedResponse: {
      type: Object,
      required: true
    }
  },
  computed: {
    answer() {
      const { label } = this.choices[this.expectedResponse.choice]
      return this.$t('tasting.section.summary.answers.color', { label })
    },
    color() {
      return this.choices[this.expectedResponse.choice].value
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/hexagon.scss';

.color-container {
  display: flex;
  flex-direction: row;
  align-items: center;

  .hexagon {
    margin-right: 30px;
  }

  .color-label {
    font-size: 16px;
  }
}
</style>
